import * as d from "shared/src/date.mjs";

const appointmentDelayedBy = (appointmentTime) => {
  const now = new Date();
  const appointment = d.parseDateTime(appointmentTime);
  // Use getTime() for type-safe subtraction under TypeScript / JS type checking.
  const diff = now.getTime() - appointment.getTime();
  if (diff < 0) {
    return 0;
  }
  const totalMinutes = Math.floor(diff / 1000 / 60);

  return totalMinutes;
};

const searchAppointments = (appointments, searchTerm, statuses = []) => {
  const searchTerms = searchTerm.split(" ").map((term) =>
    term
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, ""),
  );

  let filteredAppointments = appointments;
  if (statuses.length) {
    filteredAppointments = filteredAppointments.filter((appointment) =>
      statuses.includes(appointment.status_id),
    );
  }
  searchTerms.forEach((term) => {
    filteredAppointments = filteredAppointments.filter(
      (appointment) =>
        appointment.client.first_name
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .includes(term) ||
        appointment.client.last_name
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .includes(term) ||
        String(appointment.client.labs_id ?? "").includes(term) ||
        appointment.client.birth_number?.includes(term) ||
        appointment.client.phone?.includes(term) ||
        appointment.start.split(" ")[1].includes(term) ||
        appointment.start.split(" ")[1].replace(":", "").includes(term),
    );
  });
  return filteredAppointments;
};

export { appointmentDelayedBy, searchAppointments };
